import { Badge } from '~shared/shadcn/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '~shared/shadcn/ui/tooltip';
import type { FormSyncStatus } from '../api/types';

const STATUS_STYLES: Record<FormSyncStatus, string> = {
  synced: 'bg-green-100 text-green-800 hover:bg-green-100',
  failed: 'bg-red-100 text-red-800 hover:bg-red-100',
  pending: 'bg-amber-100 text-amber-800 hover:bg-amber-100',
  skipped: 'bg-gray-100 text-gray-600 hover:bg-gray-100',
};

const STATUS_LABELS: Record<FormSyncStatus, string> = {
  synced: 'Synced',
  failed: 'Failed',
  pending: 'Pending',
  skipped: 'Skipped',
};

const STATUS_TIPS: Record<FormSyncStatus, string> = {
  synced: 'This channel finished successfully.',
  failed: 'This channel failed. Open details to see the error and retry.',
  pending: 'Waiting to sync, or a retry is queued.',
  skipped: 'Sync was turned off or intentionally skipped.',
};

export function SyncStatusBadge({ status }: { status?: FormSyncStatus }) {
  const value = status ?? 'pending';
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge variant='secondary' className={STATUS_STYLES[value]}>
            {STATUS_LABELS[value]}
          </Badge>
        </TooltipTrigger>
        <TooltipContent className='max-w-xs text-xs'>
          {STATUS_TIPS[value]}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
